import { container } from './container'

export var GatewayCheckout = {
	isGuest: () => {
		return container.get('user') && container.get('user').email.includes('guest.quomi.it')
	},
	isGuestAllowed: (param) => {

		if (container.get('source').getValue() === 'order-now') {
			return true;
		}

		if (GatewayCheckout.isGuest()) {
			if (container.get("source").getValue() === "bennet") {
        window.dispatchEvent(new CustomEvent('signin-bennet', {bubbles: true}))
				return false;
      }
			window.dispatchEvent(new CustomEvent('signup-modal', {bubbles: true, detail: param}))

			return false;
		}

		return true;
	}
}

